const LAST_SETTINGS_PAGE_KEY = "reminders:last-settings-page";
const LAST_SETTINGS_PAGE_TTL_MS = 60 * 60 * 1000;

interface LastSettingsPage {
  route: string;
  at: number;
}

function storage(): Storage | null {
  return typeof window === "undefined" ? null : window.sessionStorage;
}

function forgetLastSettingsRoute() {
  storage()?.removeItem(LAST_SETTINGS_PAGE_KEY);
}

export function rememberSettingsRoute(route: string, now = Date.now()) {
  storage()?.setItem(LAST_SETTINGS_PAGE_KEY, JSON.stringify({ route, at: now } satisfies LastSettingsPage));
}

export function getLastSettingsRoute(validRoutes: readonly string[], now = Date.now()): string | null {
  const raw = storage()?.getItem(LAST_SETTINGS_PAGE_KEY);
  if (!raw) return null;

  try {
    const saved = JSON.parse(raw) as Partial<LastSettingsPage>;
    if (
      typeof saved.route !== "string" ||
      typeof saved.at !== "number" ||
      now - saved.at > LAST_SETTINGS_PAGE_TTL_MS ||
      !validRoutes.includes(saved.route)
    ) {
      forgetLastSettingsRoute();
      return null;
    }
    return saved.route;
  } catch {
    forgetLastSettingsRoute();
    return null;
  }
}

export function getSettingsTarget(validRoutes: readonly string[]): string {
  const route = getLastSettingsRoute(validRoutes);
  return route ? `/settings/${route}` : "/settings";
}
